import { render, staticRenderFns } from "./ContractDispute.vue?vue&type=template&id=b86ddda2&scoped=true&"
import script from "./ContractDispute.vue?vue&type=script&lang=js&"
export * from "./ContractDispute.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b86ddda2",
  null
  
)

export default component.exports